import { Injectable } from '@angular/core';
import { RestService } from '../../services/core/rest.service';

export const apiUrl = {
    API: 'Master'
}
export const hydrotestConstant = {
    GetDropdownByName: apiUrl.API + '/GetDropdownByName',
    GetSearchDropdowns: apiUrl.API + '/GetSearchDropdowns',
    GetTestPlanDropdowns: apiUrl.API + '/GetTestPlanDropdowns',
    GetSegmentsBySystemCode: apiUrl.API + '/GetSegmentsBySystemCode',// /{systemCode}
    Login:'login',
}
@Injectable({
    providedIn: 'root'
})
export class HydrotestService {

    constructor(private rest: RestService) { }

    GetSearchDropdowns() { return this.rest.get(hydrotestConstant.GetSearchDropdowns); }
    GetTestPlanDropdowns() { return this.rest.get(hydrotestConstant.GetTestPlanDropdowns); }
    GetSegmentsBySystemCode(systemCode: string) {
        return this.rest.get(hydrotestConstant.GetSegmentsBySystemCode + '/' + systemCode);
    }
    login() { return this.rest.get(hydrotestConstant.Login); }
}
